import React, { useEffect, useState } from 'react';
import { IQuestions } from 'src/redux/features/surveys/takingSurvey/types';
import {
  IPutAllQuestions,
  IPutQuestion,
} from 'src/redux/features/surveys/putTakingSurvey/types';
import { connect } from 'react-redux';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';
import { IconClose } from '@consta/uikit/IconClose';
import { putTakingSurvey } from 'src/redux/features/surveys/putTakingSurvey/actions';
import { IPutAnswers } from 'src/redux/features/surveys/putTakingSurvey/types';

import styles from './styles.styl';

import cn from 'classnames/bind';
import Answers from 'src/components/TakingSurveyContent/Answers';
import { locationNotApi } from 'src/utils/api';
import { State } from 'src/redux/reducer';
import {
  putTakingSurveyLoadedSelector,
  putTakingSurveyPendingSelector,
} from 'src/redux/features/surveys/putTakingSurvey/selectors';
import { withTooltip } from '@consta/uikit/withTooltip';
import { TextField } from '@consta/uikit/TextField';
import { SurveyStatusEnum, SurveyTypeEnum } from 'src/utils/enum';
import { myPreset } from 'src/utils/myPreset';
import { Theme } from '@consta/uikit/Theme';
import { Modal } from '@consta/uikit/Modal';
import { Informer } from '@consta/uikit/Informer';

const cx = cn.bind(styles);

export interface TakingSurveyContentProps {
  questions: IQuestions[];
  status: number;
  turnStep: (step: string) => void;
  hash: string;
  isPutSurveyPending: boolean;
  isPutSurveyLoaded: boolean;
  isSurveyReRejected?: boolean;
  putTakingSurvey: (hash: string, data: IPutAllQuestions) => void;
  type: number;
}

export interface ITextField {
  value: string | null;
  name?: string;
}

const TakingSurveyContent: React.FC<TakingSurveyContentProps> = ({
  questions,
  status,
  turnStep,
  hash,
  putTakingSurvey,
  isPutSurveyPending,
  type,
}) => {
  const [answers, setAnswers] = useState<IPutQuestion[]>([]);
  const [questionChecked, setQuestionChecked] = useState<boolean>(true);
  const [openedComments, setOpenedComments] = useState<number[]>([]);
  const [namesWithoutAnswers, setNamesWithoutAnswers] = useState<
    (string | number)[][]
  >([]);

  useEffect(() => {
    const questionsStructure = questions.map(({ id }) => {
      return { question_id: id, comment: null, answers: null };
    });

    setAnswers(questionsStructure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeAnswers = (id: number, chosenAnswers?: IPutAnswers[]) => {
    let newArr;
    if (chosenAnswers === undefined) {
      newArr = answers.map((question) => {
        if (question.question_id === id) {
          question.answers = null;
          return question;
        }
        return question;
      });
    } else {
      newArr = answers.map((question) => {
        if (question.question_id === id) {
          question.answers = chosenAnswers;
          return question;
        }
        return question;
      });
    }
    setAnswers(newArr);
  };

  const finalSurvey = () => {
    const questionsWithoutAnswersId = answers
      .map(({ answers, question_id }, index) => {
        if (
          questions.some(
            ({ id, is_required }) => question_id === id && is_required,
          ) &&
          (!answers ||
            !answers.length ||
            answers.some(({ value }) => !value || !value.trim()))
        ) {
          return [question_id, index + 1];
        }
      })
      .filter((item) => item);
    if (!questionsWithoutAnswersId.length) {
      if (status === SurveyStatusEnum.DRAFT) {
        turnStep('final');
      } else {
        const changedAnswers = answers.map((item) => {
          if (!Array.isArray(item.answers)) {
            item.answers = [];
            return item;
          } else {
            const filterAnsw = item.answers.filter((answ) => {
              if (!answ.value) {
                null;
              } else {
                return answ;
              }
            });
            return { ...item, answers: filterAnsw };
          }
        });
        putTakingSurvey(hash, { questions: changedAnswers });
      }
    } else {
      let iterator = 0;
      const namesWithoutAnswers = questions
        .map(({ id, name, is_required }) => {
          if (!is_required) {
            return;
          }
          if (questionsWithoutAnswersId.some(([item]) => item === id)) {
            const arr = [name, questionsWithoutAnswersId[iterator][1]];
            iterator++;
            return arr;
          }
        })
        .filter((item) => item);
      setNamesWithoutAnswers(namesWithoutAnswers);
      setQuestionChecked(false);
    }
  };

  const onOpenComment = (id: number) => {
    setOpenedComments((prevState) => [...prevState, id]);
  };

  const fieldChange = ({ value, name }: ITextField) => {
    const newArr = answers.map((item) => {
      if (item.question_id === Number(name)) {
        return { ...item, comment: value };
      }
      return item;
    });

    setAnswers(newArr);
  };

  const findValueField = (id: number) => {
    let value: string;
    answers.forEach((val) => {
      if (val.question_id === id) {
        value = val.comment;
      }
    });
    return value;
  };

  const svgComment = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4ZM20 17.17L18.83 16H4V4H20V17.17ZM13 5H11V9H7V11H11V15H13V11H17V9H13V5Z"
        fill="#00395C"
        fillOpacity="0.8"
      />
    </svg>
  );

  const tooltipConfig = { appearTimeout: 1000 };

  const CommentTooltip = withTooltip(tooltipConfig)(Text);

  const modalQuestions = namesWithoutAnswers.map(([item, index]) => {
    return <div key={index}>{`${index}. ${item}`}</div>;
  });

  const displayQuestions = questions.map(
    (
      { name, id, type, answers, images, is_comment, is_required, rating },
      index,
    ) => {
      let image;
      if (!images.length) {
        image = null;
      } else {
        const [{ path, filename }] = images;
        image = (
          <div className={cx('TakingSurveyContent__image')}>
            <img src={locationNotApi + path} alt={filename} />
          </div>
        );
      }

      return (
        <div className={cx('TakingSurveyContent__item')} key={id}>
          <div className={cx('TakingSurveyContent__title')}>
            {openedComments.indexOf(id) === -1 && is_comment && (
              <Theme preset={myPreset}>
                <CommentTooltip
                  tooltipProps={{
                    content: (
                      <Text
                        size="s"
                        lineHeight="s"
                        className={cx('TakingSurveyContent__tooltipText')}
                      >
                        Комментарий к вопросу
                      </Text>
                    ),
                  }}
                  className={cx('TakingSurveyContent__tooltipComment')}
                >
                  <div onClick={() => onOpenComment(id)}>{svgComment}</div>
                </CommentTooltip>
              </Theme>
            )}
            <Text size="m" lineHeight="m" weight="bold">
              {is_required && (
                <span className={cx('TakingSurveyContent__star')}>*</span>
              )}
              {`${index + 1}. ${name}`}
            </Text>
          </div>
          {openedComments.indexOf(id) !== -1 && (
            <div className={cx('TakingSurveyContent__comment')}>
              <TextField
                name={`${id}`}
                onChange={fieldChange}
                value={findValueField(id)}
                placeholder="Комментарий к вопросу"
                type="text"
                width="full"
              />
            </div>
          )}
          {image}
          <Answers
            type={type}
            answers={answers}
            question_id={id}
            changeAnswers={changeAnswers}
            rating={rating}
          />
        </div>
      );
    },
  );

  const modalWindow = (
    <Modal
      isOpen={!questionChecked}
      hasOverlay
      onClickOutside={() => setQuestionChecked(true)}
      onEsc={() => setQuestionChecked(true)}
      className={cx('TakingSurveyContent__modal')}
    >
      <Informer
        className={cx('TakingSurveyContent__modalContent')}
        status="alert"
        view="bordered"
      >
        <div className={cx('TakingSurveyContent__modalTitle')}>
          <div>Невозможно отправить результат</div>
          <IconClose size="s" onClick={() => setQuestionChecked(true)} />
        </div>
        <div className={cx('TakingSurveyContent__modalDescription')}>
          Для того чтобы завершить опрос, необходимо дать хотя бы один ответ на
          следующие вопросы:
        </div>
        <div className={cx('TakingSurveyContent__modalQuestionsContainer')}>
          {modalQuestions}
        </div>
        <Button
          className={cx('TakingSurveyContent__modalButton')}
          label="Спасибо, понятно"
          onClick={() => setQuestionChecked(true)}
        />
      </Informer>
    </Modal>
  );

  return (
    <div className={cx('TakingSurveyContent')}>
      {displayQuestions}
      <div className={cx('TakingSurveyContent__buttonContainer')}>
        <Button
          label={
            type === SurveyTypeEnum.TEST
              ? 'Завершить тестирование'
              : 'Завершить опрос'
          }
          onClick={finalSurvey}
          loading={isPutSurveyPending}
        />
      </div>
      {!questionChecked && modalWindow}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  putTakingSurvey: (hash: string, data: IPutAllQuestions) =>
    dispatch(putTakingSurvey(hash, data)),
});

const mapStateToProps = (state: State, props: any) => ({
  isPutSurveyPending: putTakingSurveyPendingSelector(state),
  isPutSurveyLoaded: putTakingSurveyLoadedSelector(state, props),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TakingSurveyContent);
